import { User as User_kojaro } from './User.kojaro';
import { User as User_phosphor } from './User.phosphor';
import { User as User_zoomg } from './User.zoomg';
import { User as User_zoomit } from './User.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return User_kojaro;

    case 'zoomg':
      return User_zoomg;

    case 'phosphor':
      return User_phosphor;

    default:
      return User_zoomit;
  }
};

export const User = IconRenderer();
